import React, { FC, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { Api } from '@.api';
import { Layout } from '@.layout';
import { CreateProductProposalsForm } from '@/Components/Partials/ProductProposals';
import { ProductProposal } from '@/Services/api/methods/ProductsProposals';
import { ProductProposalResource } from '@/Services/api/methods/ProductsProposals/types';
import { PermissionProps } from '@/Types';

import S from './styles.module.scss';

type ProductProposalsCreateProps = {
    edit?: boolean;
} & PermissionProps;

const convertProductProposalsToProductType = (productProposal: ProductProposal): ProductProposalResource => {
    return {
        name: productProposal.name,
        sexes: productProposal.sexes,
        ages: productProposal.ages,
        characters: productProposal.characters,
        ingredients: productProposal.ingredients,
        occasions: productProposal.occasions,
        tags: productProposal.tags,
        type: productProposal.type,
        strength: productProposal.strength,
        images: productProposal.images,
        brand: productProposal.brand,
        id: productProposal.id,
        created_at: productProposal.created_at,
        description: productProposal.description,
        prices: productProposal.prices,
        brand_name_en: productProposal.brand_name_en,
        brand_state: productProposal.brand_state,
        status: productProposal.status,
        reject_reason: productProposal.reject_reason,
        is_duplicating_product: productProposal.is_duplicating_product,
        company: productProposal.company,
        product: productProposal.product,
        updated_at: productProposal.updated_at,
    };
};

export const ProductProposalsCreate: FC<ProductProposalsCreateProps> = ({ permissions, edit }) => {
    const [product, setProduct] = useState<ProductProposal | undefined>(undefined);

    const { id } = useParams();

    const numberId = Number(id);

    useEffect(() => {
        if (edit && numberId) {
            Api.productsProposals()
                .getById(numberId)
                .onSuccess((response) => setProduct(response.data));
        }
    }, [edit, numberId]);

    const initialProductState = product ? convertProductProposalsToProductType(product) : undefined;

    return (
        <Layout name="ProductProposalsCreate" nobg contentClassName={S.layout}>
            <CreateProductProposalsForm id={numberId} permissions={permissions} edit={edit} initialProductState={initialProductState} withPrices={edit} />
        </Layout>
    );
};
